@if (task() && response) {
  <div class="responseDetail">
    <h3 class="responseHeader">{{ task().name }}</h3>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Entity ID:</label>
      </span>
      <span class="inputField">
        <label>{{ task().entityId }};{{ task().entityRevision }}</label>
      </span>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Complexity</label>
      </span>
      <span class="inputField">
        <select class="inputField" [(ngModel)]="response.sfrComplexity">
          @for (complexity of sfrComplexities(); track complexity) {
            <option [value]="complexity.code"
            >{{ complexity.description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Comments</label>
      </span>
      <span>
        <textarea class="inputField" rows="3" cols="40" [(ngModel)]="response.comments"></textarea>
      </span>
    </div>
    <div class="toolbar">
      <span class="link">
        <a href="{{safariLink()}}" target="_blank">Click Here To View Details in Safari</a>
      </span>
      <span class="spacer"></span>
      <span>
        <button class="primary-button" matButton="elevated" [disabled]="!response || !response.sfrComplexity || isBusy()"
          (click)="saveResponse()">
          <span>
            <mat-icon class="size-16">done</mat-icon>
            <label>Complete Task</label>
          </span>
        </button>
      </span>
    </div>
  </div>
}
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}

